module.exports = __webpack_public_path__ + "static/media/arruda-alecrim.9a5f4bb0.png";